import React from "react";
import { createRoot } from "react-dom/client";

// @todo tsxファイルにして、絶対パス指定にする。
import App from "./App";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
